import {
  ContactStatus,
  ICampaign,
  IContact,
  IForm,
  ITag,
  ObjectId,
} from "../generated/Api";
import { INoteCategory } from "./NoteCategory";

export enum INoteExternalSystem {
  "SOCIAL_LAIR" = "SOCIAL_LAIR",
}

export enum INoteTrigger {
  "CONTACT_CREATED" = "CONTACT_CREATED",
  "TAG_APPLIED" = "TAG_APPLIED",
  "TAG_REMOVED" = "TAG_REMOVED",
  "USER_NOTE" = "USER_NOTE",
  "FORM_SUBMIT" = "FORM_SUBMIT",
  "STATUS" = "STATUS",
}

export enum INoteFrom {
  "CONTACT_SCREEN" = "CONTACT_SCREEN",
  "IMPORT_CSV" = "IMPORT_CSV",
  "CAMPAIGN" = "CAMPAIGN",
  "FORM" = "FORM",
}
export interface INoteGeneric {
  _id?: ObjectId;

  text: string;
  trigger: INoteTrigger;
  params: unknown;

  ip: string;
  deviceId: string;
  categoryId: string;

  createdAt: Date;

  userUid: string;
  externalSystem?: INoteExternalSystem;
}

export type INoteTagParams =
  | {
      tag: ITag;
      contact: IContact;
      from: INoteFrom.CONTACT_SCREEN | INoteFrom.IMPORT_CSV;
    }
  | {
      tag: ITag;
      contact: IContact;
      from: INoteFrom.FORM;
      form: IForm;
    }
  | {
      tag: ITag;
      contact: IContact;
      from: INoteFrom.CAMPAIGN;
      campaign: ICampaign;
    };

export type INoteFormSubmitParams = {
  form: IForm;
  contact: IContact;
  from: INoteFrom.FORM;
  externalUser: any;
  description: string;
};

export type INoteUserParams = {
  contact: IContact;
  from: INoteFrom.CONTACT_SCREEN;
};

export type INoteStatusParams = {
  contact: IContact;
  from: INoteFrom.CONTACT_SCREEN;
  status: ContactStatus;
};

export interface INoteTagApplied extends INoteGeneric {
  trigger: INoteTrigger.TAG_APPLIED;
  params: INoteTagParams;
}

export interface INoteTagRemoved extends INoteGeneric {
  trigger: INoteTrigger.TAG_REMOVED;
  params: INoteTagParams;
}

export interface INoteFormSubmit extends INoteGeneric {
  trigger: INoteTrigger.FORM_SUBMIT;
  params: INoteFormSubmitParams;
}

export interface INoteUser extends INoteGeneric {
  trigger: INoteTrigger.USER_NOTE;
  params: INoteUserParams;
}
export interface INoteStatus extends INoteGeneric {
  trigger: INoteTrigger.STATUS;
  params: INoteStatusParams;
}

export type INote =
  | INoteTagApplied
  | INoteTagRemoved
  | INoteFormSubmit
  | INoteUser;

export type CreateNoteIRoute = Omit<INote, "categoryId" | "text"> & {
  categoryId?: string;
  text?: string;
};

export interface ContactNote {
  _id: string;
  createdAt: Date;
  text: string;
  ip: string;
  deviceId: string;
  browser: string;
  device: string;
  os: string;
  trigger: INoteTrigger;
  category: INoteCategory;
  from: INoteFrom;
}
